import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Logo2 from '../images/fisibility-logo (1).3dfce7e15ecf3ec78691 2.png';
import footerImg from "../images/footer-img.png";
import { useLanguage } from '../Providers/LanguageContext';
import { UserContext } from '../Providers/UserWrapper';
import privace_En from '../images/blog_pdfs/Fisibility - Privacy Policy_En.pdf';
import privace_Es from '../images/blog_pdfs/privacy_police_Es.pdf'
import girl from '../images/Group 6.c3b8abe37711a35f664b 1.png'

function Footer() {
  const { language, currentLanguage } = useLanguage()
  const { profileData, isLogin } = useContext(UserContext);
  const userData = reactLocalStorage.getObject('userData')
  // console.log('userDataclip', userData)
  const handleOpenRoute = () => {
    const routeUrl = '/Privacy'; // Replace with your desired route URL
    window.open(routeUrl, '_blank');
  };

  const location = useLocation();

  return (
    <footer id='footer-section' style={{
      background: 'linear-gradient(to bottom,rgb(255 255 255 ),#0C2537)',
      boxShadow: '0px -5px 5px rgb(0 0 0 / 5%)'
    }}>
      <div className='container-fluid footer-container'>
        <div className='footer-content'>
          <div className='footer-top'>
            <div className='footer-top-content'>
              {/* <Link to={Object.keys(userData).length ? isBookKeeper ? "/bookkeeper-manager" : '/manager' : '/'}> */}
              <Link to={isLogin ? '/manager' : "/"}>
                <div className='footer-logo'>
                  <img className="img-fluid" src={Logo2} alt='...' />
                </div>
              </Link>
              <p style={{ position: 'relative', bottom: '0px', right: '0px', fontFamily: 'Roboto' }}>Powered by CIP</p>
            </div>
          </div>
          <div className='footer-mid'>
            <div className='social-links'>
              {/* <a href='#'><i className="fa-solid fa-t"></i></a> */}
              <a href='https://facebook.com/Fisibility' target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
              <a href='https://twitter.com/FisibilityAI' target="_blank"><i className="fa-brands fa-twitter"></i></a>
              <a href='https://youtube.com/@FisibilityLite' target="_blank"><i className="fa-brands fa-youtube"></i></a>
              <a href='https://instagram.com/FisibilityAI' target="_blank"><i className="fa-brands fa-instagram"></i></a>
              {/* <a href='#'><i className="fa-brands fa-linkedin-in"></i></a> */}
            </div>
            <div className='footer-link'>
              <ul>
                <li ><Link style={{
                  color: 'white',
                  fontWeight: '600'
                }} to="/" >{language.headerMenu1}</Link></li>
                <li><Link style={{
                  color: 'white',
                  fontWeight: '600'
                }} to="/product-tour" >{language.headerMenu4}</Link></li>
                <li><Link style={{
                  color: 'white',
                  fontWeight: '600'
                }} to="/Blog" >{language.headerMenu2}</Link></li>
                <li><Link style={{
                  color: 'white',
                  fontWeight: '600'
                }} to="/Nosotros">{language.headerMenu3}</Link></li>
                <li><Link style={{
                  color: 'white',
                  fontWeight: '600'
                }} to="/deleteaccount">Delete Account</Link></li>
              </ul>
            </div>
            <div className='footer-mail'>
              <a href='mailto:support@fisibility.com'>support@fisibility.com</a>
              <a style={{ cursor: "pointer" }} onClick={handleOpenRoute} >{language.privacy_policy}</a>
            </div>
          </div>
          <div className='footer-login' style={{
            visibility: 'hidden'
          }}>
            {
              !profileData && (
                <Link to="/login">{language.loginButton}</Link>
              )
            }
            {/* <h5 className='text-light'>Support@fisibility.com</h5> */}
          </div>
          <div className='footer-bottom'>
            <div>
              <p>Copyright© 2026 Fisibility</p>
            </div>
          </div>
        </div>

        <div className="footer-img-wrapper">
          <div className="footer-img-container">
            <div className="f-shape1"></div>
            <div className="footer-img">
              <img src={footerImg} />
            </div>
            <div className="shape-right">
              <div className="f-shape2"></div>
              <div className="f-shape3"></div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer